import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function dashBoardReducer(state = initialState.dashboard, action) {
  switch (action.type) {
    case types.DASHBOARD_SETTINGS:
      return action.dashboard;

    // case types.LOGIN:
    //   return {};
  
    case types.LOGIN_SUCCEEDED:
      return {
        ...state,
        token: action.payload
      };      
 
    default:
      return state;
  }
}